module.exports = __webpack_public_path__ + "img/red1.6fef0470.png";